<script>
    import _ from 'lodash'

    export default {
        props: {
            callstack: {
                type: Object,
                required: true
            },
            executeOnCreated: {
                type: Boolean,
                default: true
            }
        },
        created () {
            if (this.executeOnCreated) this.execute()
        },
        data () {
            return {
                is_loading: false,
                has_loaded: false,
                results: {},
                errors: []
            }
        },
        methods: {
            execute () {
                this.is_loading = true

                this.values = []
                this.errors = []

                Promise.all(
                    _.chain(this.callstack)
                        .keys()
                        .map(key => {
                            return this.callstack[key]()
                                .then(value => {
                                    return { key, value }
                                })
                                .catch(error => {
                                    return error
                                })
                        })
                        .value()
                )
                    .then(items => {
                        this.is_loading = false

                        _.each(items, item => {
                            if (_.isError(item)) {
                                this.errors.push(item)
                            } else {
                                this.results[item.key] = item.value
                            }
                        })

                        if (_.isEmpty(this.errors)) {
                            this.has_loaded = true

                            this.$emit('success', this.results)
                        } else {
                            this.$emit('error', this.errors)
                        }
                    })
                    .catch(() => {
                        this.is_loading = false
                    })
            }
        },
        render () {
            return this.$scopedSlots.default({
                is_loading: this.is_loading,
                has_loaded: this.has_loaded,
                execute: this.execute,
                results: this.results,
                errors: this.errors
            })
        }
    }
</script>
